import { SVGProps } from 'react';

export const WrenchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M24.41 20.805 7.905 37.31a4.798 4.798 0 0 0 0 6.785v0a4.798 4.798 0 0 0 6.785 0L31.196 27.59a10.78 10.78 0 0 0 13.769-6.96c.463-1.392.627-2.864.483-4.323a2.16 2.16 0 0 0-3.683-1.226l-3.91 3.91a1.083 1.083 0 0 1-1.531 0l-3.314-3.314c-.423-.423-.424-1.108.404-1.936l3.506-3.506a2.161 2.161 0 0 0-1.226-3.682 10.438 10.438 0 0 0-4.316.48 10.78 10.78 0 0 0-6.968 13.772h0Z'
      clipRule='evenodd'
    />
  </svg>
);
